import React from 'react';

const CompGroupsContext = React.createContext(null);

export default CompGroupsContext;
